import { c as _c } from "react/compiler-runtime";
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
import { GOOGLE_INTEGRATIONS_API } from '../api';
import { IntegrationInterface, IntegrationUseCaseEnum } from '../types';
export const useGoogleIntegrations = () => {
  const $ = _c(19);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: fetchIntegrations
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.delete
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: removeIntegrationFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] !== user) {
    t2 = () => {
      if (!user) {
        return;
      }
      return [GOOGLE_INTEGRATIONS_API, RequestModuleEnum.GoogleIntegrations];
    };
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data,
    mutate,
    isLoading
  } = useControlledSwr(t2, fetchIntegrations, undefined);
  let t3;
  if ($[4] !== removeIntegrationFetcher) {
    t3 = async id => {
      await removeIntegrationFetcher(`${GOOGLE_INTEGRATIONS_API}/${id}`);
    };
    $[4] = removeIntegrationFetcher;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const removeIntegration = t3;
  let t4;
  if ($[6] !== data) {
    t4 = useCase => {
      if (!data) {
        return;
      }
      return {
        ...data,
        items: data.items.filter(e => e.useCases.includes(useCase))
      };
    };
    $[6] = data;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const getIntegrationsByUseCase = t4;
  let t5;
  if ($[8] !== getIntegrationsByUseCase) {
    t5 = getIntegrationsByUseCase(IntegrationUseCaseEnum.Calendar)?.items.length;
    $[8] = getIntegrationsByUseCase;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const isGoogleCalendarIntegrated = t5 !== 0;
  let t6;
  if ($[10] !== mutate) {
    t6 = async item => {
      await mutate(data_0 => {
        if (!data_0) {
          return;
        }
        let newItems = data_0.items;
        if (data_0.items.find(e_1 => e_1.id === item.id)) {
          newItems = newItems.map(e_0 => e_0.id === item.id ? item : e_0);
        } else {
          newItems = [item, ...newItems];
        }
        return {
          ...data_0,
          items: newItems
        };
      }, false);
    };
    $[10] = mutate;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const mutateIntegrationsWithNewItem = t6;
  let t7;
  if ($[12] !== getIntegrationsByUseCase || $[13] !== isGoogleCalendarIntegrated || $[14] !== isLoading || $[15] !== mutate || $[16] !== mutateIntegrationsWithNewItem || $[17] !== removeIntegration) {
    t7 = {
      isLoading,
      isGoogleCalendarIntegrated,
      getIntegrationsByUseCase,
      mutate,
      removeIntegration,
      mutateIntegrationsWithNewItem
    };
    $[12] = getIntegrationsByUseCase;
    $[13] = isGoogleCalendarIntegrated;
    $[14] = isLoading;
    $[15] = mutate;
    $[16] = mutateIntegrationsWithNewItem;
    $[17] = removeIntegration;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};